import { Box, Heading, Stack, Text, theme } from "@chakra-ui/react";
import NextImage from "next/image";

import CustomLink from "components/Chakra/CustomLink";
import CustomWrapper from "components/Chakra/CustomWrapper";
import IconInfoCircle from "components/Chakra/Icons/InfoCircle";
import IconInIkona from "components/Chakra/Icons/InIkona";
import IconOffer from "components/Chakra/Icons/Offer";
import MetaHead from "components/MetaHead";
import CardOption from "./CardOption";

const InsertOffer: React.FC = function InsertOffer() {
  return (
    <>
      <MetaHead
        title="Vložení inzerátu"
        description="Tisíce zájemců právě hledají bydlení na UlovDomov.cz. Jsme jednička na českém trhu pronájmů. Inzerujte už od 49 Kč."
      />
      <Box position="relative">
        <Box
          position="absolute"
          zIndex={-3}
          h={{ base: "338px", sm: "439px", "2xl": "600px" }}
          w="100%"
        >
          <NextImage
            priority
            quality={80}
            src="/img/scenes/InsertOffer/bg-image.jpg"
            alt="hlavni obrazek"
            blurDataURL="/img/scenes/obsazko/bg_thumb.jpg" // TODO
            placeholder="blur"
            fill
            style={{ objectFit: "cover", objectPosition: "50% 80%" }}
          />
        </Box>
        <CustomWrapper
          maxW="1050px"
          pt={{ base: "50px", md: "168px", "2xl": "285px" }}
          pb={{ base: "32px", md: "80px" }}
        >
          <Heading
            as="h2"
            variant="h2"
            textAlign="center"
            fontSize="50px"
            lineHeight="57px"
            color="ud-white"
            pb="16px"
          >
            Inzerujte na UlovDomov
          </Heading>
          <Text
            textAlign="center"
            fontSize="16px"
            lineHeight="18px"
            color="ud-white"
          >
            Najděte nájemníky pro svoji nemovitost
          </Text>

          <Stack
            py={{ base: "40px", md: "80px", "2xl": "120px" }}
            gap="20px"
            direction={{ base: "column", md: "row" }}
            justifyContent="center"
            w="100%"
            sx={{
              "> *": {
                flex: 1,
              },
              [`@media (min-width: ${theme.breakpoints.md})`]: {
                "> *": {
                  maxWidth: "337px",
                },
              },
            }}
          >
            <CardOption
              title="Chci službu Ideální nájemce"
              description="Nájemné vždy a včas, pronájem kompletně bez starostí."
              price="Zdarma"
              linkProps={{
                href: "https://idealninajemce.cz",
              }}
              trackEventPayload={{
                "dl.eCat": "offer_create",
                "dl.eAct": "bttn.clicked",
                "dl.eLab": "Ideální nájemce",
              }}
              icon={<IconInIkona fillWith="ud-primary" boxSize="24px" />}
            />
            <CardOption
              title="Inzerovat sám"
              description="Až 14 000 lidí u nás denně hledá bydlení."
              price="Od 49 Kč"
              linkProps={{
                to: "/vlozeni-inzeratu/formular/kontakt",
              }}
              trackEventPayload={{
                "dl.eCat": "offer_create",
                "dl.eAct": "bttn.clicked",
                "dl.eLab": "Vložit inzerát",
              }}
              icon={<IconOffer fillWith="ud-primary" boxSize="24px" />}
            />
          </Stack>
          <Stack
            margin="0 auto"
            direction="row"
            align="center"
            spacing="16px"
            p="9px"
            borderWidth="1px"
            borderColor="ud-yellow-300"
            borderRadius="6px"
            backgroundColor="ud-yellow-100"
            width={{ base: "100%", md: "337px" }}
          >
            <IconInfoCircle boxSize="32px" />
            <CustomLink
              showUnderline
              trackEventPayload={{
                "dl.eCat": "offer_create",
                "dl.eAct": "link.clicked",
                "dl.eLab": "LP inzerce RK",
              }}
              to="/pro-realitni-kancelare"
            >
              Nabídka inzerce pro realitní kanceláře.
            </CustomLink>
          </Stack>
        </CustomWrapper>
      </Box>
    </>
  );
};

export default InsertOffer;
